/* eslint-disable sort-keys */
import Auth from '../managers/AuthManager';
import basicIframeModalLauncherManager from '../managers/BasicIframeModalLauncherManager';
import contentManager from '../managers/ContentManager';
import userManager from '../managers/UserManager';

import { registerClass } from '../SatCoreRegistry';
import { generateRobustUrl } from '../utils';

export default class BasicIframeModalLauncherService {
  static allowGettingStartedIframeModalLauncher = (iframeModalLauncherObj) => {
    const obj = iframeModalLauncherObj || this.getFloatingHelpIframeLauncherMapEntryValue();
    const isMicrosite = obj?.resourceType === 'microsite_resource';
    return obj?.url || (isMicrosite && obj?.resourceId);
  }

  static getDashboardGettingStartedIframeLauncherMapEntryValue = () => {
    if (userManager.isDistrictOrSchoolAdmin) {
      return basicIframeModalLauncherManager.basicIframeModalLauncherUrlMap?.get(
        'DASHBOARD_GETTING_STARTED_ADMIN'
      );
    } else if (userManager.isTeacher) {
      return basicIframeModalLauncherManager.basicIframeModalLauncherUrlMap?.get(
        'DASHBOARD_GETTING_STARTED_TEACHER'
      );
    } else if (userManager.isStudent) {
      return basicIframeModalLauncherManager.basicIframeModalLauncherUrlMap?.get(
        'DASHBOARD_GETTING_STARTED_STUDENT'
      );
    }
    return null;
  }

  static allowFloatingHelpIframeModalLauncher = (iframeModalLauncherObj) => {
    const obj = iframeModalLauncherObj || this.getFloatingHelpIframeLauncherMapEntryValue();
    const isMicrosite = obj?.resourceType === 'microsite_resource';
    return obj?.url || (isMicrosite && obj?.resourceId);
  }

  static getFloatingHelpIframeLauncherMapEntryValue = () => {
    if (userManager.isDistrictOrSchoolAdmin) {
      return basicIframeModalLauncherManager.basicIframeModalLauncherUrlMap?.get(
        'FLOATING_HELP_ADMIN'
      );
    } else if (userManager.isTeacher) {
      return basicIframeModalLauncherManager.basicIframeModalLauncherUrlMap?.get(
        'FLOATING_HELP_TEACHER'
      );
    } else if (userManager.isStudent) {
      return basicIframeModalLauncherManager.basicIframeModalLauncherUrlMap?.get(
        'FLOATING_HELP_STUDENT'
      );
    }
    return null;
  }

  static getDashboardGettingStartedIframeModalLauncherUrl = async (iframeModalLauncherObj) => {
    iframeModalLauncherObj = iframeModalLauncherObj || this.getDashboardGettingStartedIframeLauncherMapEntryValue();
    return this.generateIframeModalLauncherUrl(iframeModalLauncherObj);
  }

  static getFloatingHelpIframeModalLauncherUrl = async (iframeModalLauncherObj) => {
    iframeModalLauncherObj = iframeModalLauncherObj || this.getFloatingHelpIframeLauncherMapEntryValue();
    return this.generateIframeModalLauncherUrl(iframeModalLauncherObj);
  }

  static generateIframeModalLauncherUrl = async (iframeModalLauncherObj) => {
    if (!iframeModalLauncherObj) {
      return null;
    }

    const obj = iframeModalLauncherObj;

    const isMicrosite = obj?.resourceType === 'microsite_resource';
    if (isMicrosite && obj.resourceId/* && obj.contentItemId */) {
      const micrositeRedirectUrl = await contentManager.fetchMicrositeRedirectUrl({
        resourceId: obj.resourceId
      });
      return micrositeRedirectUrl;
    } else if (iframeModalLauncherObj.url) {
      const customParamObj = this.getIframeLauncherUrlCustomParamObj(iframeModalLauncherObj.customParamKeys);
      return generateRobustUrl(iframeModalLauncherObj.url, customParamObj);
    }

    return null;
  }

  static getIframeLauncherUrlCustomParamObj = (customParamKeys) => {
    if (Array.isArray(customParamKeys)) {
      const customParamObj = {
        ...(customParamKeys.includes('authKey') ? { authKey: Auth.authKey } : {}),
        ...(customParamKeys.includes('ecmsBaseUrl') ? { ecmsBaseUrl: Auth.ecms } : {})
      };
      return customParamObj;
    } else {
      return {};
    }
  }
}

registerClass('BasicIframeModalLauncherService', BasicIframeModalLauncherService);
